export const projects = [
  {
    id: 1,
    title: 'Voiced - AI-Powered Appointment Booking SaaS',
    description: 'Architected an innovative SaaS platform that revolutionizes appointment scheduling through intelligent voice agents, enabling businesses to automate their booking processes with natural telephonic interactions powered by advanced AI.',
    tech: ['Django REST Framework', 'Next.js', 'Vapi AI', 'Docker', 'Tailwind CSS', 'PostgreSQL', 'WebRTC', 'TypeScript'],
    highlights: [
      'Engineered full-stack SaaS architecture with Django REST backend and Next.js frontend',
      'Integrated Vapi AI framework for natural language voice agent capabilities',
      'Developed real-time telephonic booking system with intelligent conversation flows',
      'Implemented multi-tenant architecture supporting scalable business operations',
      'Built containerized microservices architecture with Docker for seamless deployment',
      'Created responsive UI/UX with Tailwind CSS for optimal user experience',
      'Designed robust API endpoints for seamless voice agent and booking system integration',
      'Delivered automated appointment scheduling with conflict resolution and calendar sync'
    ],
    type: 'professional'
  },
  {
    id: 2,
    title: 'ReAct Agent for Mathematical Computing',
    description: 'Engineered an intelligent ReAct agent that seamlessly integrates advanced AI reasoning with mathematical computation tools, revolutionizing automated problem-solving for complex integral calculus.',
    tech: ['Python', 'LangChain', 'LangGraph', 'Streamlit', 'PostgreSQL', 'Docker', 'Matplotlib', 'SymPy'],
    highlights: [
      'Architected production-ready LangGraph ReAct workflow',
      'Developed BigTool semantic tool selection system for intelligent automation',
      'Integrated Google Gemini 2.5 Flash for enhanced reasoning capabilities',
      'Created interactive mathematical visualizations with real-time rendering',
      'Implemented robust PostgreSQL persistence layer for data integrity',
      'Delivered containerized deployment solution with Docker',
      'Built comprehensive Jupyter test suite ensuring reliability'
    ],
    link: 'https://github.com/gmartincor/Euler-LanGraph-Agent',
    type: 'professional'
  },
  {
    id: 3,
    title: 'TimeOverflow - Alliance System',
    description: 'Architected and delivered an innovative inter-organizational alliance system that revolutionizes collaboration between time bank communities, enabling seamless resource sharing across distributed networks.',
    tech: ['Ruby on Rails', 'PostgreSQL', 'JavaScript', 'Leaflet.js', 'Highcharts'],
    highlights: [
      'Designed full-stack MVC architecture from ground up',
      'Built interactive geospatial visualization platform',
      'Implemented secure cross-organizational transaction system',
      'Drove open source community adoption and engagement'
    ],
    link: 'https://github.com/coopdevs/timeoverflow',
    type: 'open-source'
  },
  {
    id: 4,
    title: 'Zento ERP - Multi-Tenant Business Management System',
    description: 'Architected a comprehensive enterprise-grade ERP system enabling scalable management of complex organizational hierarchies with professional-grade invoicing and complete data sovereignty.',
    tech: ['Django', 'PostgreSQL', 'Python', 'Docker', 'Gunicorn', 'Tailwind CSS'],
    highlights: [
      'Engineered multi-tenant architecture utilizing PostgreSQL schemas',
      'Engineered a professional invoicing module capable of generating custom PDF reports',
      'Developed advanced data export system supporting multiple formats (CSV, Excel, ZIP, JSON)',
      'Implemented hierarchical business structure management',
      'Created real-time analytics dashboard providing actionable business insights'
    ],
    link: 'https://github.com/gmartincor/zento_erp',
    type: 'professional'
  },
  {
    id: 5,
    title: 'Healthcare ML Integration Platform',
    description: 'Engineered a robust machine learning integration platform that seamlessly connects AI algorithms with healthcare applications, accelerating medical decision-making and improving patient outcomes.',
    tech: ['Django', 'Svelte', 'Python', 'RESTful APIs', 'Docker'],
    highlights: [
      'Architected high-performance APIs for real-time data exchange',
      'Optimized system performance and enhanced response efficiency',
      'Delivered comprehensive test coverage ensuring system reliability',
      'Designed scalable architecture to handle increased data throughput',
      'Integrated ML models with secure healthcare data protocols'
    ],
    type: 'professional'
  }
];
